<script setup lang="ts">
import { useCityStore } from '@/store/city/city'

import { NewProduct } from '@/types/api/api-v4/product'
import { Slider, SliderType } from '@/types/api/api-v4/slider'

import MainCategoryFactoid from '@/components/Main/MainCategoryFactoid.vue'
import MainFactoid from '@/components/Main/MainFactoid.vue'
import ProductCard from '@/components/Product/ProductCard/ProductCard.vue'

type Props = {
  slide: Slider
  sliderType: SliderType
}

const props = defineProps<Props>()

const emit = defineEmits(['openDialogProduct'])

const cityStore = useCityStore()

const cityTitle = computed(() => {
  return cityStore?.cityInfo?.padeg?.pred || 'вашем городе'
})

const isSalesSlider = computed(() => {
  return props.sliderType === SliderType.SALE
})

const titleElementTag = computed(() => (isSalesSlider.value ? 'div' : 'h2'))

const openDialogProduct = (product: NewProduct) => {
  emit('openDialogProduct', {
    currentProduct: product,
    productList: props.slide.products,
    visible: true,
  })
}
</script>

<template>
  <section class="category">
    <div class="category__header">
      <!-- Так как мы должны соблюдать вложенность h тегов, а h1 страницы находится в фактоиде этого(первого) блока, мы меняем h тег на обычный div-->
      <component :is="titleElementTag" class="category__title">
        {{ slide.name }}
      </component>

      <nuxt-link
        v-if="!isSalesSlider"
        :to="slide.link.path"
        class="category__link"
      >
        <div>{{ slide.link.title }}</div>

        <the-icon name="expand-right" size="32" color="var(--ui-primary)" />
      </nuxt-link>
    </div>

    <div class="category__products">
      <the-slider :space-between="32" :slide-width="276" :slides-to-scroll="4">
        <main-factoid v-if="isSalesSlider" :city-title="cityTitle" />

        <main-category-factoid v-if="slide.factoid" :factoid="slide.factoid" />

        <template v-for="product in slide.products" :key="product.id">
          <product-card
            class="category__product"
            :product="product"
            @on-open-dialog="openDialogProduct"
          />
        </template>
      </the-slider>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.category {
  width: 100%;
  padding: 0 0 100px;

  &__header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
  }

  &__title {
    height: max-content;
    font-size: 22px;
    font-weight: 900;
    color: var(--ui-text-primary);
  }

  &__link {
    display: flex;
    align-items: center;
    font-size: 22px;
    font-weight: 900;
  }

  &__products {
    display: flex;
    max-width: 100%;
    height: 100%;
  }

  &__product {
    flex-shrink: 0;
    width: 276px;
  }
}
</style>
